/**
 * The hashtag for the emails that is tagged for big screen.
 */
export const TAG_EMAIL_HASHTAG = '#TagEmailForBigScreen';
